import { render } from "./FilePreviewComponent.vue?vue&type=template&id=66846ab2&scoped=true"
import script from "./FilePreviewComponent.vue?vue&type=script&lang=js"
export * from "./FilePreviewComponent.vue?vue&type=script&lang=js"

import "./FilePreviewComponent.vue?vue&type=style&index=0&id=66846ab2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66846ab2"]])

export default __exports__